import { createContext, useContext } from 'react';
import PropTypes from 'prop-types';
import { ThemeProvider } from '@emotion/react';
import { useSelector } from 'react-redux';
import { selectTheme } from '@chronos/pwa/slices/appSlice';
import themes from '@chronos/ui-toolkit/themes';
import { ThemeContext } from '@chronos/ui-toolkit/contexts';

const AppThemeProvider = ({ children }) => {
  const theme = useSelector(selectTheme);
  const currentTheme = themes[theme];

  return (
    <ThemeContext.Provider value={theme}>
      <ThemeProvider theme={currentTheme}>{children}</ThemeProvider>
    </ThemeContext.Provider>
  );
};

AppThemeProvider.propTypes = {
  children: PropTypes.node.isRequired,
};

export const useAppTheme = () => {
  const context = useContext(ThemeContext);

  if (context === undefined) {
    throw new Error('useTheme must be used within a AppThemeProvider');
  }

  return context;
};

export default AppThemeProvider;
